export default __webpack_public_path__ + "static/960-5c5ed9b3cacc440480ec28f829a4ac13.gif";